export default __webpack_public_path__ + "static/banner-keyrus-ai-702a62e1b2623ab347e1462146b3792f.svg";